import { isEqualsObject } from "./ObjectUtils";
/**
 * Utilitaire contenant des fonctions statiques pour les tableaux
 * @category Utils
 * @hideconstructor
 */

var ArrayUtils = /*#__PURE__*/function () {
  function ArrayUtils() {}

  /**
   * Comparaison de 2 tableaux d'objets
   * @param {array} array1 Tableau d'objet 1 pour la comparaison
   * @param {array} array2 Tableau d'objet 2 pour la comparaison
   * @returns {boolean} true si les 2 tableaux sont égaux, false sinon
   */
  ArrayUtils.isEqualsArrayOfObject = function isEqualsArrayOfObject(array1, array2) {
    if (!array1 || !array2) {
      return false;
    }

    if (array1.length !== array2.length) {
      return false;
    }

    var keys1 = Array.from(Object.keys(array1));
    var keys2 = Array.from(Object.keys(array2));

    if (keys1.length !== keys2.length) {
      return false;
    }

    for (var i = 0; i < keys1.length; i++) {
      var key = keys1[i];

      if (!isEqualsObject(array1[key], array2[key])) {
        return false;
      }
    }

    return true;
  };

  return ArrayUtils;
}();

export var isEqualsArrayOfObject = ArrayUtils.isEqualsArrayOfObject;